import React, { useEffect, useState } from "react";
import TextButton from "@components/ui/buttons/TextButton";
import { useTranslation } from "react-i18next";
import { t_help } from "@i18n/usualTexts/t_help";

export interface Props {
  sendCodeEmail: Function;
  timeLabel?: string;
  linkLabel?: string;
  intervalTime?: number;
}

const TimeForNewVerify: React.FC<Props> = ({ sendCodeEmail, timeLabel, linkLabel, intervalTime = 180 }) => {
  const [seconds, setSeconds] = useState(intervalTime - 1);
  const { t } = useTranslation();

  const timeLabelText = timeLabel ?? t(t_help.timeForNewCodeText);
  const linkLabelText = linkLabel ?? t(t_help.timeForNewCodeLink);
  const countdownText = t("help.timeForNewCodeCountdown", { seconds });

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(prevSeconds => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        }
        return prevSeconds;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex-grow mt-4 text-start">
      <div className="w-10/12">
        {seconds > 0 ? (
          <span className="text-[var(--text-secondary)]">
            {timeLabelText + " " + countdownText}
          </span>
        ) : (
          <TextButton onClick={() => {
            setSeconds(intervalTime);
            sendCodeEmail();
          }}>
            {linkLabelText}
          </TextButton>
        )}
      </div>
    </div>
  );
};

export default TimeForNewVerify;
